import { Button, Card, Flex, Modal, Spin } from "antd";
import { getAccountById, toggleAccountStatus } from "api/services/AccountService";
import { AccountStatus, TAccount } from "api/services/models/types";
import { WebDPrivilege } from "api/services/models/WebDUser";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import ErrorViewer from "components/ErrorViewer";
import { useEffect, useState } from "react";
import AddOrUpdateAccount from "./AddOrUpdateAccount";

const ManageAccount = () => {
  const { accountId, webDUser } = useTDAuthentication();
  const [account, setAccount] = useState<TAccount>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>();
  const [showNewAccount, setShowNewAccount] = useState(false);

  useEffect(() => {
    if (accountId) {
      setLoading(true);
      setError(null);
      getAccountById(accountId)
        .then(setAccount)
        .catch(setError)
        .finally(() => setLoading(false));
    }
  }, [accountId]);

  const onToggleAccountStatus = () => {
    if (account) {
      setLoading(true);
      setError(null);
      toggleAccountStatus(account)
        .then(setAccount)
        .catch(setError)
        .finally(() => setLoading(false));
    }
  };

  const onAddNewAccount = () => {
    setShowNewAccount(true);
  };

  if (!accountId || !webDUser?.hasPrivilege(WebDPrivilege.ManageAccount)) {
    return <span>Forbidden</span>;
  }

  return (
    <Card
      style={{
        padding: "16px"
      }}
      className="default-border"
      styles={{ body: { padding: "0" } }}>
      {loading && (
        <Flex justify="space-around" style={{ width: "100%", textAlign: "center" }}>
          <Spin tip="Saving, please wait..." />
        </Flex>
      )}
      {error && <ErrorViewer error={error} />}
      {!loading && (
        <>
          <AddOrUpdateAccount account={account} onDone={setAccount} onCancel={() => setShowNewAccount(false)}/>
          {webDUser?.isInternalUser() && (
            <Flex wrap justify="space-between">
              <Button
                type="link"
                onClick={onToggleAccountStatus}
                style={{
                  color: account?.accountStatus === AccountStatus.Active ? "#FF3535" : "#1868db"
                }}>
                {account?.accountStatus === AccountStatus.Active
                  ? "Disable this Account"
                  : "Enable this Account"}
              </Button>

              <Button type="link" onClick={onAddNewAccount}>
                Add New Account
              </Button>
            </Flex>
          )}
        </>
      )}
      {webDUser?.isInternalUser() && showNewAccount && (
        <Modal
          open={showNewAccount}
          maskClosable={false}
          closeIcon={null}
          footer={null}
          centered={true}
           className="custom-modal">
          <AddOrUpdateAccount onDone={() => setShowNewAccount(false)} onCancel={() => setShowNewAccount(false)}/>
        </Modal>
      )}
    </Card>
  );
};

export default ManageAccount;
